export default __webpack_public_path__ + "static/media/404.6fc51f10.png";